import { LogoV2 } from "@components/icons"
import Bracket from "ui/assets/icons/Bracket"
import Car from "ui/assets/icons/Car"
import DoorIcon from "ui/assets/icons/Cardoor"
import SeatIcon from "ui/assets/icons/Carseat"
import { Step } from "./types"

export const steps: Step[] = [
  {
    label: "Vehicle",
    icon: <Car height={24} width={24} />,
    options: [],
  },
  {
    label: "Seat",
    icon: <SeatIcon height={46} width={46} />,
    options: [],
  },
  {
    label: "Door",
    icon: <DoorIcon height={46} width={46} />,
    options: [],
  },
  {
    label: "Bracket",
    icon: <Bracket height={46} width={46} />,
    options: [],
  },
  {
    label: "Summary",
    icon: <LogoV2 />,
    options: [],
  },
]
